export const howItWorksConfig = [
  {
    title: 'partner-depts.apply-online',
    img: 'https://media.umangapp.in/cdn/landing/our-partner/apply-online.svg',
    url: 'usc/login',
  },
  {
    title: 'partner-depts.share-api',
    img: 'https://media.umangapp.in/cdn/landing/our-partner/api.svg',
    url: '',
  },
  {
    title: 'partner-depts.int-with-umang',
    img: 'https://media.umangapp.in/cdn/landing/our-partner/api.svg',
    url: '',
  },
  {
    title: 'partner-depts.testing',
    img: 'https://media.umangapp.in/cdn/landing/our-partner/api.svg',
    url: '',
  },
  {
    title: 'partner-depts.go-live',
    img: 'https://media.umangapp.in/cdn/landing/our-partner/api.svg',
    url: '',
  },
];
